<template>
  <div class="campaignReport">
    <div class="campaignReport__header">
      <div class="campaignReport__header__back"></div>
      <div class="campaignReport__header__title">
        <div class="campaignName">
          <h1>{{dataMeasurement.title}}</h1>
        </div>
        <div class="action">
          <button class="btn-regular secondary">Download</button>
        </div>
      </div>
    </div>
    <div class="campaignReport__body">
      <div class="campaignReport__chart">
        <div class="campaignReport__chart__header">
          <div class="campaignReport__chart__header__filter">
            <h3>Overview</h3>
            <div class="filter">
              <v-date-picker v-if="myRange.start" class="calendar"
                mode='range'
                :popoverVisibility="'focus'"
                :theme-styles='themeStyles'
                popover-align="right"
                v-model='myRange'
                :min-date='convertDate(minDate)'
                :max-date='convertDate(maxDate)'
                :attributes='attributes'
                :show-day-popover="false"
                :is-double-paned="checkOneMonth()"
                show-caps>
                <input
                  class="calendar-base"
                  type='text'
                  slot-scope='{ inputValue, updateValue }'
                  disabled
                  :value='inputValue'
                  @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                  @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
              </v-date-picker>
              <div class="custom">
                <button class="btn-small secondary">Hour</button>
                <button class="btn-small secondary" :class="{active: filter == 'day'}" @click.stop="changeFilter('day', 'filter')">Day</button>
                <button class="btn-small secondary" :class="{active: filter == 'week'}" @click.stop="changeFilter('week', 'filter')">Week</button>
                <button class="btn-small secondary" :class="{active: filter == 'month'}" @click.stop="changeFilter('month', 'filter')">Month</button>
              </div>
            </div>
          </div>
          <div class="campaignReport__chart__header__card">
            <!-- hide this information for now 
            <div class="card" :class="{active: filterTotal == 'impression'}" @click.stop="changeFilter('impression', 'filterTotal')">
              <h1 class="subhead">Total Impression</h1>
              <h2 class="medium-title">{{dataMeasurement.total_impression | formatNumber}}</h2>
            </div> -->
            <div class="card" :class="{active: filterTotal == 'traffic'}" @click.stop="changeFilter('traffic', 'filterTotal')">
              <h1 class="subhead">Total Traffic</h1>
              <h2 class="medium-title">{{dataMeasurement.total_traffic | formatNumber}}</h2>
            </div>
          </div>
        </div>
        <div class="campaignReport__chart__graph">
          <adx-line-chart
            v-if="chartData != null && this.loaded"
            :chartdata.sync="chartData"
            :options="options"/>
        </div>
      </div>
      <div class="campaignReport__info">
        <div class="campaignReport__info__menu">
          <div class="wrapper">
            <router-link tag="div" :to="{name: 'campaignreportv2-location'}" class="item subhead">SPBU</router-link>
            <router-link tag="div" :to="{name: 'campaignreportv2-gender'}"  class="item subhead">Gender</router-link>
            <router-link tag="div" :to="{name: 'campaignreportv2-age'}"  class="item subhead">Age</router-link>
            <!-- <router-link tag="div" :to="{name: 'campaignreportv2-ses'}"  class="item subhead">SES</router-link>
            <router-link tag="div" :to="{name: 'campaignreportv2-vehicle'}"  class="item subhead">Vehicle Type</router-link> -->
          </div>
        </div>
        <div class="campaignReport__info__detail">
          <router-view v-if="!loadingDemographic" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LineChart from '@/components/Chart/LineChart'

import api from '@/api'
import { apiV2 } from '@/api/urls'
import moment from 'moment'
import _ from 'lodash'

export default {
  name: 'adx-dashboard-campaign-report-v2',
  components: {
    'adx-line-chart': LineChart,
  },
  props: {

  },
  data() {
    return {
      baseChartData: null,
      chartData: null,
      options: {
        responsive: true, 
        maintainAspectRatio: false, 
        legend: false,
        scales: {
          xAxes: [
            {
              gridLines: {
                color: "rgba(0, 0, 0, 0)",
              }
            },
          ],
          yAxes: [{
            ticks: {
              // stepSize: 10,
              beginAtZero: true
            }
         }]
        },
        tooltips: {
          titleFontSize : 15,
          bodyFontSize : 15,
          backgroundColor: 'rgba(250,	252, 254)',
          borderColor : 'rgba(0, 0, 0, 0.08)',
          bodyFontColor: '#999999',
          titleFontColor: '#262626',
          borderWidth: 2,
          custom: function(tooltip) {
            if (!tooltip) return;
            tooltip.displayColors = false;
          },
        }
      },
      filterDate: null,
      filter: 'day',
      loaded: false,
      filterTotal: 'impression',
      dataMeasurement: {
        title: '',
        total_impression: 0,
        total_traffic: 0
      },
      dataDemographic: {
        age: [],
        gender: {male: 0, female: 0}
      },
      disabledDates: {
        start : null,
        end : null
      },
      myRange: {
        start: null,
        end: null
      },
      themeStyles: {
        dayContent: {
          fontSize: '15px',
        },
        headerTitle: {
          fontSize: '17px',
          fontWeight: 'bold'
        },
        weeks: {
          fontWeight: 'bold'
        },
        wrapper: {
          boxShadow: '0 1px 4px 0 #f0f0f3',
          backgroundColor: 'white',
          border: 'none',
        },
        header: {
          marginBottom: '6px'
        },
        dayCellNotInMonth: {
          opacity: 0,
        }
      },
      attributes: [
        {
          dates: [],
          highlight: {
            backgroundColor: '#ff3b30',
          },
        },
        {
          dates: [],
          dot: {
            backgroundColor: '#ff3b30',
          },
        }
      ],
      maxDate: null,
      minDate: null,
      loadingDemographic: false
    }
  },
  computed: {

  },
  watch: {
    filter: async function () {
      this.loaded = false
      this.chartData = await this.mapDataFilter(this.baseChartData)
      this.loaded = true
    },
    filterTotal: async function () {
      this.loaded = false
      this.chartData = await this.mapDataFilter(this.baseChartData)
      this.loaded = true
    },
    myRange() {
      this.loadDataChart()
      this.loadDataDemographic()
    },
  },
  beforeCreate() {

  },
  async created() {
    await this.loadDataMeasurement()
  },
  beforeMount() {

  },
  async mounted() {

    await this.loadDataChart()
    await this.loadDataDemographic()
    let ticks = this.options.scales.xAxes[0]
    ticks['ticks'] = {
      maxTicksLimit : 15,
      maxRotation : 0,
      callback: label => {
        return label
      }
    }
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    loadDataChart() {
      (async () => {
        this.loaded = false

        const params = {
          start: this.myRange.start ? moment(this.myRange.start).format("YYYY-MM-DD") : undefined,
          end: this.myRange.end ? moment(this.myRange.end).format("YYYY-MM-DD") : undefined
        }

        const response = await api.get(apiV2.measurementPertaminaChart(this.$route.params.campaign_id), {params, needToken: true })
        if (response.status == 200) {
          const { data } = response
          this.baseChartData = await data
          this.chartData = await this.mapDataFilter(data)
          this.loaded = true

        } else {
          this.chartData = []
        }
      })();
    },
    loadDataMeasurement() {
      (async () => {

        const response = await api.get(apiV2.measurementPertamina(this.$route.params.campaign_id), { needToken: true })
        if (response.status == 200) {
          const { data } = response
          this.dataMeasurement = await data

          this.minDate = await new Date(data.start)
          this.maxDate = await new Date(data.end)
          this.myRange.start = await new Date(data.start)
          this.myRange.end = await new Date(data.end)

          this.attributes[0].dates = []
          this.attributes[0].dates.push(this.myRange.start, this.myRange.end)
          // this.attributes[1].dates.push(date)
        } else {
          this.dataMeasurement = {
            title: '',
            total_impression: 0,
            total_traffic: 0
          }
        }
      })();
    },
    loadDataDemographic() {
      (async () => {
        this.loadingDemographic = true
        const params = {
          start: this.myRange.start ? moment(this.myRange.start).format("YYYY-MM-DD") : undefined,
          end: this.myRange.end ? moment(this.myRange.end).format("YYYY-MM-DD") : undefined
        }
 
        const response = await api.get(apiV2.measurementPertaminaDemographic(this.$route.params.campaign_id), { params,  needToken: true })
        if (response.status == 200) {
          const { data } = response
          this.dataDemographic = await data
          this.loadingDemographic = false

        } else {
          this.dataDemographic = []
          this.loadingDemographic = false
        }
      })();
    },
    async mapDataFilter(data) {
      const item = _.orderBy(data, o => {
        return moment(moment(o.date).format('YYYY-MM-DD'))
      }, ['asc'])

      let result;

      switch (this.filter) {
        case 'day':
          return {
            labels: item.map(x => x.date),
            datasets: [{
              backgroundColor: 'transparent',
              borderColor: '#FF2D55',
              data: item.map(x => x[this.filterTotal])
            }]
          }
          break;
        case 'week':
          const seven = item.filter((z, index) => {
            if (index % 7 === 0 ) return index
          })
          seven.unshift(0)

          result = seven.map((element, index) => {
            return item.filter((x, index1) => index1 >= element && index1 <= element + 7)
          });
          return await this.mapData(result, item)
          break;
        case 'month':
          const month = [...new Set(item.map(z => moment(z.date).format('MM')))]

          result = month.map(element => {
            return item.filter(x => moment(x.date).format('MM') == element)
          });
          return await this.mapData(result, item)
          break;
      }

    },
    mapData (data, item) {
      const dataset = data.map(x => {
        return x.reduce((total, current) => total + current[this.filterTotal], 0)
      })

      let label;
      if(data.length > 1){
        label = data.map((x, index) => {
          return `${item[x].date} - ${item[index + 1].date}`
        })
      }else {
        label = [`${item[0].date} - ${item[item.length - 1].date}`]
      }

      return {
        labels: label,
        datasets: [{
          backgroundColor: 'transparent',
          borderColor: '#FF2D55',
          data: dataset
        }]
      }
    },
    changeFilter(args, data) {
      this[data] = args
    },
    convertDate(value) {
      return new Date(value)
    },
    checkOneMonth() {
      return moment(this.myRange.start).format('MM') === moment(this.myRange.end).format('MM') ? false : true
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>
